import type * as React from 'react'

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '../components/ui/empty'
import { cn } from '../lib/utils'

type EmptyStateProps = {
  title: React.ReactNode
  description?: React.ReactNode
  icon?: React.ComponentType<{ className?: string }>
  /** Próximo passo (normalmente um Button para criar o primeiro item). */
  action?: React.ReactNode
  /**
   * `card` (padrão): caixa tracejada, para listas e seções.
   * `inline`: sem caixa e mais compacto, para dentro de um card ou painel.
   */
  variant?: 'card' | 'inline'
  className?: string
}

/** Lista ou seção sem nada ainda: diz o que falta e qual o próximo passo. */
function EmptyState({
  title,
  description,
  icon: Icon,
  action,
  variant = 'card',
  className,
}: EmptyStateProps) {
  return (
    <Empty
      data-variant={variant}
      className={cn(
        variant === 'card' ? 'border' : 'gap-4 p-6 md:p-8',
        className
      )}
    >
      <EmptyHeader>
        {Icon ? (
          <EmptyMedia variant="icon">
            <Icon />
          </EmptyMedia>
        ) : null}
        <EmptyTitle className="text-base">{title}</EmptyTitle>
        {description ? (
          <EmptyDescription>{description}</EmptyDescription>
        ) : null}
      </EmptyHeader>
      {action ? <EmptyContent>{action}</EmptyContent> : null}
    </Empty>
  )
}

export { EmptyState, type EmptyStateProps }
